
import { useContext, useState } from 'react';
import { TaskDef, findTaskDefByAgent } from '../../apis/mgmt/api';
import { useReadOnly } from '../common/DataView';
import { useApiFilteredPaginatedList } from '../common/FilteredPaginatedList';
import { ListProps, SectionListLayout, useStatefulList } from '../common/List';
import { useStatefulPaging } from '../common/Paging';
import { TaskDefCard } from './TaskDefCard';
import { Auth, Role } from '../../apis/Auth';

export const useTaskDefListByAgent = function (props: {
    agentId: string | undefined,
}) {
    return useApiFilteredPaginatedList<string, TaskDef>({
        filterProps: useReadOnly(props.agentId),
        listProps: useStatefulList<TaskDef>(),
        pagingProps: useStatefulPaging(),
        filterToQueryParams: (agentId: string) => ({ agentId, size: 1000 }),
        apiQueryFunc: findTaskDefByAgent
    });
};

export function TaskDefSectionList(props: {
    listProps: ListProps<TaskDef>
}) {

    const { onAddItem, data } = props.listProps;
    const { is } = useContext(Auth);

    const [ selectedItem, setSelectedItem ] = useState<TaskDef | undefined>(undefined);
    const onSelectedItem = (item: TaskDef) => {
        setSelectedItem(item);
        props.listProps.onSelectedItem && props.listProps.onSelectedItem(item);
    }
    
    return (
        <SectionListLayout title="Tareas" onCreateClick={is(Role.TECHNICIAN) && onAddItem || undefined} >
            {data && data.map((itemData: TaskDef, index: number) => (
                <TaskDefCard
                    key={itemData.id} 
                    data={itemData}
                    setData={(data) => props.listProps.setItemOrDeleteOld(data, itemData)}
                    onClick={onSelectedItem}
                    selected={selectedItem?.id === itemData.id}
                />
            ))}
        </SectionListLayout>
    );

}